import { calculateCycles } from 'routes/Studies/routes/CreateStudy/utils/studyUtils'

const asId = value => (value == null ? '' : String(value))

const studyDurationInDays = template => {
  if (!template || template.studyDuration === '' || template.studyDuration == null) return null
  return template.durationType === 'weeks' ? Number(template.studyDuration) * 7 : Number(template.studyDuration)
}

const cycleDayLength = cycle => {
  const days = cycle?.cycleDuration ?? cycle?.duration
  const parsed = Number(days)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null
}

/** Create Study stores one template row; participant chapters are 1..N over study duration. */
const isCollapsedChapterTemplate = cycles =>
  cycles?.length === 1 &&
  cycles[0]?.cycleDuration != null &&
  cycles[0]?.studyDuration != null &&
  cycles[0]?.duration == null

const chapterRows = count =>
  Array.from({ length: count }, (_, index) => ({
    id: String(index + 1),
    name: `Chapter ${index + 1}`,
  }))

const totalChaptersForDynamicPattern = (pattern, studyDays) => {
  if (!pattern.length || !studyDays) return pattern.length
  let remaining = studyDays
  let count = 0
  let index = 0
  const maxChapters = 5000
  while (remaining > 0 && count < maxChapters) {
    const duration = cycleDayLength(pattern[index % pattern.length]) || 1
    count += 1
    remaining -= duration
    index += 1
  }
  return count || pattern.length
}

/**
 * Chapter deploy anchors target participant chapter numbers (1..N), not reward-config rows.
 * See studyUtils.calculateCycles / generateCycles for how chapters are derived from study config.
 */
export const buildChapterOptions = (study = {}) => {
  const config = study?.config || {}
  const cycles = config.cycles || study?.cycles || []
  if (!cycles.length) return []

  const hasDynamic = Boolean(config.has_dynamic_cycles)

  if (isCollapsedChapterTemplate(cycles) && !hasDynamic) {
    const count = calculateCycles(cycles[0])
    if (count > 0) return chapterRows(count)
  }

  if (hasDynamic) {
    const patternDays = cycles.map(cycleDayLength).reduce((sum, days) => (days ? sum + days : sum), 0)
    const studyDays = studyDurationInDays(cycles[0]) ?? (patternDays || null)
    const count = totalChaptersForDynamicPattern(cycles, studyDays)
    if (count > 0) return chapterRows(count)
  }

  if (cycles.length > 1 || cycleDayLength(cycles[0])) {
    return cycles.map((cycle, index) => ({
      id: asId(cycle.id ?? index + 1),
      name: cycle.name || cycle.label || `Chapter ${index + 1}`,
    }))
  }

  return chapterRows(1)
}
